import { render } from "./CustomerInquiry.vue?vue&type=template&id=c1171b96&scoped=true"
import script from "./CustomerInquiry.vue?vue&type=script&lang=js"
export * from "./CustomerInquiry.vue?vue&type=script&lang=js"

import "./CustomerInquiry.vue?vue&type=style&index=0&id=c1171b96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1171b96"

export default script